import React from 'react'
import cn, { Argument as ClassName } from 'classnames'
import styled, { ThemeProvider } from 'styled-components'

import { SInput } from '../input-group'
import { theme } from '../theme'

export const SCheckbox = styled.span<{ checked: boolean; disabled: boolean; inverted: boolean }>`
    position: relative;
    display: inline-block;
    width: 18px;
    height: 18px;
    border-radius: 3px;
    border: 2px solid
        ${({ theme, disabled, inverted }) =>
            disabled
                ? theme.checkbox.disabledBgColor
                : inverted
                  ? theme.checkbox.invertedBgColor
                  : theme.checkbox.bgColor};
    background-color: ${({ theme, checked, disabled, inverted }) =>
        !checked
            ? 'transparent'
            : disabled
              ? theme.checkbox.disabledBgColor
              : inverted
                ? theme.checkbox.invertedBgColor
                : theme.checkbox.bgColor};
    color: ${({ theme, disabled, inverted }) =>
        disabled
            ? theme.checkbox.disabledMarkColor
            : inverted
              ? theme.checkbox.invertedMarkColor
              : theme.checkbox.markColor};
    line-height: 18px;

    &:hover {
        opacity: 0.5;
    }
    &:disabled {
        cursor: not-allowed;
        pointer-events: none;
    }
`

const SSvg = styled.svg`
    position: absolute;
    top: 2px;
    left: -1px;
`

const SCheckboxLabel = styled.label`
    display: flex;
    align-items: center;
    gap: 4px;
    font-weight: 200;
    cursor: pointer;

    &:disabled {
        cursor: not-allowed;
        pointer-events: none;
    }
`
const STitle = styled.span`
    font-weight: 400;
`

export type CheckboxInputProps = {
    setChecked?: (check: boolean) => void
    checked?: boolean
    disabled?: boolean
    inverted?: boolean
    label?: string
    className?: ClassName
    style?: React.CSSProperties
    dataTestId?: string
}

export function CheckboxInput({
    setChecked,
    checked = false,
    disabled = false,
    inverted = false,
    label,
    className,
    style,
    dataTestId,
}: CheckboxInputProps): React.ReactElement {
    return (
        <div className={cn(className)} style={style} data-testid={dataTestId ?? 'checkboxInput'}>
            <ThemeProvider theme={theme}>
                <SInput
                    checked={checked}
                    disabled={disabled}
                    type="checkbox"
                    id={dataTestId}
                    className="hidden"
                    onChange={(e) => {
                        if (!disabled) setChecked(e.target.checked)
                    }}
                    data-testid={dataTestId ? dataTestId + 'check' : 'rememberMeBtn'}
                />
                <SCheckboxLabel htmlFor={dataTestId} data-testid="label">
                    <SCheckbox checked={checked} disabled={disabled} inverted={inverted}>
                        <SSvg width="16" height="11" viewBox="0 0 17 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                            {checked && (
                                <path
                                    d="M17.54 0L8.70997 8.83C7.94997 9.58 6.94997 10 5.87997 10C4.80997 10 3.80997 9.58 3.04997 8.83L0.219971 6H3.04997L4.45997 7.41C5.21997 8.17 6.53997 8.17 7.28997 7.41L14.7 0H17.54Z"
                                    fill={
                                        disabled
                                            ? theme.checkbox.disabledMarkColor
                                            : inverted
                                              ? theme.checkbox.invertedMarkColor
                                              : theme.checkbox.markColor
                                    }
                                    data-testid="checkmark"
                                />
                            )}
                        </SSvg>
                    </SCheckbox>
                    {label && <STitle>{' ' + label}</STitle>}
                </SCheckboxLabel>
            </ThemeProvider>
        </div>
    )
}
